import { LoadingButton } from "@mui/lab";
import {
  Box,
  TextField,
  FormControlLabel,
  Switch,
  Typography,
  Stack,
  LinearProgress,
  Alert,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { getErrorResponse, getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";
import useApiEp from "../../hooks/useApiEp";

const LeadsNotificationToggle = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [leadsEnabled, setLeadsEnabled] = useState(false);
  const [saving, setSaving] = useState(false);

  const { data, isLoading, isError, error } = useApiEp(
    `/user/get-leads-notification-settings`
  );

  // ---> Populate state when API returns data
  useEffect(() => {
    if (data?.leadNotificationSingle) {
      setPhoneNumber(data.leadNotificationSingle.phoneNumber || "");
      setLeadsEnabled(data.leadNotificationSingle.leadsEnabled || false);
    }
  }, [data]);

  if (isLoading) {
    return <LinearProgress />;
  }

  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  const handleSave = async () => {
    try {
      setSaving(true);
      const response = await axios.post(
        `${API_ENDPOINT}/user/save-leads-notification-settings`,
        { phoneNumber, leadsEnabled },
        getHeader()
      );
      toast.success(response.data.message);
    } catch (error) {
      toastError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 420 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
        Leads Notification
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        This phone number will receive an SMS/WhatsApp notification whenever a
        new <strong>lead</strong> is generated for your account.
      </Typography>

      <Stack direction="row" spacing={2}>
        <TextField
          fullWidth
          label="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="Enter phone number"
          margin="normal"
          type="tel"
        />
      </Stack>

      <FormControlLabel
        control={
          <Switch
            checked={leadsEnabled}
            onChange={(e) => setLeadsEnabled(e.target.checked)}
            color="primary"
          />
        }
        label="Enable Leads Notification"
        sx={{ mt: 3 }}
      />

      <LoadingButton
        variant="contained"
        color="primary"
        loading={saving}
        onClick={handleSave}
        fullWidth
        sx={{ mt: 3 }}
      >
        Save
      </LoadingButton>
    </Box>
  );
};

export default LeadsNotificationToggle;
